module.exports = __webpack_public_path__ + "static/media/auditorium.0b7ec490.jpg";